import React, { useEffect, useRef } from "react";
import Header from "../templates/Header/Header";
import Main from "../templates/Main/Main";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { useRecoilState,useRecoilValue } from "recoil";
import { logoutDrpdown } from "../atoms/dashboard";
import { myCareerWheel } from "../selectors/dashboard";
function Dashboard() {
  const [, setDropDownData] = useRecoilState(logoutDrpdown);
  const careerWheelApiData = useRecoilValue(myCareerWheel);
  let driverObj,driverObj1;
  if(careerWheelApiData?.length > 0 && careerWheelApiData !='No record found'){
    driverObj1 = driver({
      showProgress: true,
      steps: [
        {  popover: { title: 'Hello!', description: '<p>Welcome to the Career portal</p>', side:"center" }},
        { element: '.avatar_details', popover: { title: 'Profile', description: ' Here is your profile Info along with Stream details' } },
        { element: '.prisecskills', popover: { title: 'Primary Skills and Secondary Skills', description: '<p>Here are your Skill Sets and its proficiency details, if required please update your skills in MySkill Portal</p>' } },
        { element: '.ceretCls', popover: { title: 'My Certification', description: '<p>Your Certificate details can be seen here, if required please update your skills in MySkill Portal </p>' } },
        { element: '.explrbtn', popover: { title: 'Job Wheel', description: '<p>Explore - Click the button to explore the suggested roles at RRD</p>' } },
        { element: '.carlatbtn', popover: { title: 'Job Wheel', description: '<p>Lattice - Click the button to view the Career Lattice at RRD in a holistic view </p>', 
       
      }
      },
        { element: '.Careerwheel', popover: { title: 'Job Wheel', description: '<p>Your Current and Proposed Role info to the max of Job Level 9 (L9), by clicking on the Level, the respective Job`s Role Info and Skill Sets will be displayed in the right side </p>',
        //     onNextClick: () => {
        //      // driverObj.drive(6);
        //   const addressEl = document.querySelector("#list-decimal-jblevl");
        //   if (addressEl) {
        //     addressEl.parentElement.children[0].scrollIntoView();
        //     driverObj.moveNext();
        //   }       
        // }, 
      } },
        {
          element: '#list-decimal-jblevl li:nth-child(0)',
          popover: {
            title: 'Job Wheel',
            description: '<p>Kindly scroll down to view.If there are more than one designation available for the selected level, then the list of all designations will be displayed below the Wheel. You can click the particular designation to view the Job`s Role Info and Skill Sets details</p>',
             side: "bottom",
          }
        },
        { element: '.Role.Information', popover: { title: 'JD & Role Info', description: '<p>The selected Job Level and Designations Role Info is displaying here, these details are evolving and its updated by the HR Team</p>' } },
        { element: '.Skill.Set', popover: { title: 'Skill Set', description: '<p>The selected Job Level and Designations Skill Set is displaying here, these details are evolving and its updated by the HR Team</p>' } },
        { element: '.Proposed.Learning', popover: { title: 'Proposed Learning', description: '<p>The selected Job Level and Designation`s Learning proposals is displaying here. Click the link to navigate to the Learn@RRD Portal</p>' } },
        { element: '.My.Journey', popover: { title: 'My Journey', description: '<p>Right from the current job, the milestone of the career progression has been listed and ended with DOJ </p>' } },
      ]
    });
   
  } else {
   driverObj1 = driver({
      showProgress: true,
      steps: [
        {  popover: { title: 'Hello!', description: '<p>Welcome to the Career portal</p>', side:"center" }},
        { element: '.avatar_details', popover: { title: 'Profile', description: ' Here is your profile Info along with Stream details' } },
        { element: '.prisecskills', popover: { title: 'Primary Skills and Secondary Skills', description: '<p>Here are your Skill Sets and its proficiency details, if required please update your skills in MySkill Portal</p>' } },
        { element: '.ceretCls', popover: { title: 'My Certification', description: '<p>Your Certificate details can be seen here, if required please update your skills in MySkill Portal </p>' } },
        { element: '.explrbtn', popover: { title: 'Job Wheel', description: '<p>Explore - Click the button to explore the suggested roles at RRD</p>' } },
        { element: '.carlatbtn', popover: { title: 'Job Wheel', description: '<p>Lattice - Click the button to view the Career Lattice at RRD in a holistic view </p>', 
       
      }
      },
     { element: '.My.Journey', popover: { title: 'My Journey', description: '<p>Right from the current job, the milestone of the career progression has been listed and ended with DOJ </p>' } },
      ]
    });
   
  }
 
  driverObj=driverObj1;

  const help_coach = () => {
    //setDropDownData(false);
    driverObj.drive();
  };

  return (
    <div className="mx-auto h-full w-full">
      <div className="main-section">
        <Header onBtnClick={help_coach} />
        <main className="p-3">
          <Main />
        </main>
      </div>
    </div>
  );
}

export default Dashboard;